var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-change-password")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-col",
            { style: { height: "100%" }, attrs: { "no-margin": "" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          password: "",
                          label: _vm.$ct("labels.password-current"),
                          fancy: "",
                          required: "",
                          autocomplete: "new-password",
                        },
                        on: {
                          blur: function ($event) {
                            _vm.usedInputs.current = true
                          },
                        },
                        model: {
                          value: _vm.inputs.current,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputs, "current", $$v)
                          },
                          expression: "inputs.current",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          password: "",
                          label: _vm.$ct("labels.password-new"),
                          fancy: "",
                          required: "",
                          autocomplete: "new-password",
                        },
                        on: {
                          blur: function ($event) {
                            _vm.usedInputs.new = true
                          },
                        },
                        model: {
                          value: _vm.inputs.new,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputs, "new", $$v)
                          },
                          expression: "inputs.new",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          password: "",
                          label: _vm.$ct("labels.password-repeat"),
                          fancy: "",
                          required: "",
                          autocomplete: "new-password",
                        },
                        on: {
                          blur: function ($event) {
                            _vm.usedInputs.repeat = true
                          },
                        },
                        model: {
                          value: _vm.inputs.repeat,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputs, "repeat", $$v)
                          },
                          expression: "inputs.repeat",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.shownErrorMessage
                ? _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c(
                            "app-error-message",
                            { attrs: { hide: _vm.shownErrorMessage == "" } },
                            [
                              _vm.shownErrorMessage
                                ? _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.shownErrorMessage) + " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    [
                      !_vm.isTotpEnabled
                        ? _c(
                            "w-link",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.enableTotp = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$ct("enable-two-factor-auth")) +
                                  " "
                              ),
                            ]
                          )
                        : _c(
                            "w-link",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.disableTotp = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$ct("disable-two-factor-auth")) +
                                  " "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("w-spacer"),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.isValid },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("submit-change-password")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.enableTotp,
            callback: function ($$v) {
              _vm.enableTotp = $$v
            },
            expression: "enableTotp",
          },
        },
        [
          _vm.enableTotp
            ? _c("app-enable-totp", {
                on: {
                  close: function ($event) {
                    return _vm.closeTotp()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.disableTotp,
            callback: function ($$v) {
              _vm.disableTotp = $$v
            },
            expression: "disableTotp",
          },
        },
        [
          _vm.disableTotp
            ? _c("app-disable-totp", {
                on: {
                  close: function ($event) {
                    return _vm.closeTotp()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }